/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5fbe6f88e4979c9709cd0d8cd5bb880c0a7a7d44";
